// extracted by mini-css-extract-plugin
module.exports = {"flag":"CustomPageEditBasic_flag__2iAmq"};